import type { BillingAccess, BillingUsage, GlobalBillingUsage, UserProfile } from '@/types';

import { request } from './client';

const appendQuery = (path: string, query?: string): string => {
  return query ? `${path}?${query}` : path;
};

export const UserApi = {
  getCurrentUser(): Promise<UserProfile> {
    return request<UserProfile>('/users/current');
  },
  getBillingUsage(query?: string): Promise<BillingUsage> {
    return request<BillingUsage>(appendQuery('/users/current/billing-usage', query));
  },
  getBillingAccess(): Promise<BillingAccess> {
    return request<BillingAccess>('/users/current/billing-usage/access');
  },
  getGlobalBillingUsage(query?: string): Promise<GlobalBillingUsage> {
    return request<GlobalBillingUsage>(appendQuery('/users/billing-usage/global', query));
  },
};
